// import '../../components/HelloWorld';

(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("adminRolesController", adminRolesController);

  adminRolesController.$inject = ["$scope", "$rootScope"];

  function adminRolesController($scope, $rootScope) {
    var vm = this;
    vm.timestamp = null;
    vm.thisUser = $rootScope.thisUser;

    // properties
    setInterval(() => {
      vm.timestamp = +new Date();
      $scope.$apply();
    }, 1000);
  }
})(angular);
